import NavbarUA from "../components/NavbarUA";
import FooterUA from "../components/FooterUA";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { FadeIn } from "../components/AnimationWrapper";
import { useRef } from "react";
import { Helmet } from "react-helmet-async";

export default function CareersUA() {
  const heroHeadingRef = useRef(null);

  return (
    <>
      <NavbarUA heroHeadingRef={heroHeadingRef} />
      <Helmet>
        <html lang="uk" />
        <title>Кар'єра – CV Box | Вакансії</title>
        <meta name="description" content="Приєднуйся до команди CV Box. Наразі відкритих вакансій немає, але ми завжди шукаємо талановитих людей." />
        <link rel="canonical" href="https://cv-box.com/ua/careers" />
      </Helmet>

      <main>
        <section className="pt-32 lg:pt-44 pb-20 bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] min-h-[40vh] flex items-center">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <FadeIn>
              <h1 ref={heroHeadingRef} className="text-4xl lg:text-5xl font-bold text-white mb-4">Кар'єра в CV Box</h1>
              <p className="text-white/60 text-lg max-w-xl mx-auto">
                Ми будуємо продукт, який змінює підхід до пошуку роботи.
              </p>
            </FadeIn>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-2xl mx-auto px-6 text-center">
            <FadeIn>
              <div className="bg-gray-50 rounded-2xl p-12">
                <span className="text-5xl mb-6 block">🚀</span>
                <h2 className="text-2xl font-medium text-gray-900 mb-4">Наразі відкритих вакансій немає</h2>
                <p className="text-gray-600 text-lg mb-6">
                  Ми завжди шукаємо талановитих людей. Якщо ти вважаєш, що можеш посилити нашу команду — напиши нам, і ми зв'яжемося з тобою, коли з'явиться відповідна позиція.
                </p>
                <a href="mailto:careers@cv-box.com" className="py-3.5 px-8 rounded-full font-bold text-base bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-400 hover:to-emerald-500 hover:shadow-lg hover:shadow-green-500/30 transition-all duration-300 inline-block">
                  Написати на careers@cv-box.com
                </a>
              </div>
            </FadeIn>
          </div>
        </section>
      </main>

      <ScrollToTopButton />
      <FooterUA />
    </>
  );
}
